module.exports = __webpack_public_path__ + "static/media/twoThirdCenter.1a175089.png";